var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"floor10-wrapper"},[_c('div',{staticClass:"content",on:{"click":function($event){return _vm.goUrl('https://wap.myzebravip.com/store/?shopId=35149')}}},[_c('img',{attrs:{"src":require("images/floor10/floor10-desc.png"),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e15b85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/floor/floor_10.vue
// module id = null
// module chunks = 